import { Flex, Box } from '@chakra-ui/react';
import React from 'react';

import { finleyAssertUnreachable } from '@finley-technologies/common';

import { VerificationStatusIcon } from './VerificationIcons';
import { FundingVerificationPipelineRunGQLType } from '../../../../types/dashboard-core-gqlTypes.generated.d';

export const VerificationStatusCellContent = ({
  pipelineStatus,
}: {
  pipelineStatus: FundingVerificationPipelineRunGQLType['status'];
}) => {
  switch (pipelineStatus) {
    case 'inProgress':
      return (
        <Flex>
          <VerificationStatusIcon status="inProgress" />
          <Box width="8px" />
          Running
        </Flex>
      );
    case 'error':
      return (
        <Flex>
          <VerificationStatusIcon status="error" />
          <Box width="8px" />
          Error
        </Flex>
      );
    case 'awaitingApproval':
      return (
        <Flex>
          <VerificationStatusIcon status="success" />
          <Box width="8px" />
          Ready to Verify
        </Flex>
      );
    case 'remediationRequested':
      return (
        <Flex>
          <VerificationStatusIcon status="remediationRequested" />
          <Box width="8px" />
          Remediation Requested
        </Flex>
      );
    case 'superseded':
      return (
        <Flex>
          <VerificationStatusIcon status="notStarted" />
          <Box width="8px" />
          Expired
        </Flex>
      );
    case 'complete':
      return (
        <Flex>
          <VerificationStatusIcon status="success" />
          <Box width="8px" />
          Approved
        </Flex>
      );
    case 'notStarted':
      // Should not be possible.
      // - notStarted: we can't know about a pipeline run if it hasn't started
      return <></>;
    default:
      throw finleyAssertUnreachable(pipelineStatus);
  }
};
